/* Localize the existing ActiveCampaign popup without changing signup or coupon handling. */
(() => {
  const root = document.getElementById('ac-popup-overlay');
  if (!root) return;
  const english = /(^|\.)mynordhaus\.com$/i.test(location.hostname) || (!/(^|\.)mynordhaus\.de$/i.test(location.hostname) && document.documentElement.lang.startsWith('en'));
  const copy = english ? {
    dialog: 'Newsletter sign-up', close: 'Close popup', name: 'Your name', email: 'Your email address',
    required: 'Please fill in this field.', invalidEmail: 'Please enter a valid email address.'
  } : {
    dialog: 'Newsletter-Anmeldung', close: 'Popup schließen', name: 'Dein Name', email: 'Deine E-Mail-Adresse',
    required: 'Bitte fülle dieses Feld aus.', invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.'
  };
  const messages = [
    ['Melde dich unten an und sichere dir 10% Rabatt auf deine erste Bestellung!', 'Sign up below and get 10% off your first order!', 'Melde dich unten an und sichere dir 10% Rabatt auf deine erste Bestellung!'],
    ['Gutschein sichern!', 'Get my discount', 'Gutschein sichern!'],
    ['Por favor, selecione uma opção.', 'Please select an option.', 'Bitte wähle eine Option aus.'],
    ['Este campo é necessário.', copy.required, copy.required],
    ['Os formulários devem ter um campo de email ou um campo de telefone', 'Please enter your email address.', 'Bitte gib deine E-Mail-Adresse ein.'],
    ['Digite um email válido', copy.invalidEmail, copy.invalidEmail],
    ['Insira um número de telefone válido.', 'Please enter a valid phone number.', 'Bitte gib eine gültige Telefonnummer ein.'],
    ['Digite uma data válida.', 'Please enter a valid date.', 'Bitte gib ein gültiges Datum ein.'],
    ['Marque esta caixa para continuar', 'Please tick this box to continue.', 'Bitte aktiviere dieses Kontrollkästchen, um fortzufahren.'],
    ['Desculpe, seu envio falhou. Deixe suas respostas mais curtas e tente novamente.', 'Your submission could not be sent. Please shorten your answers and try again.', 'Deine Anmeldung konnte nicht gesendet werden. Bitte kürze deine Angaben und versuche es erneut.'],
    ['Desculpe, seu envio falhou. Tente novamente.', 'Your submission could not be sent. Please try again.', 'Deine Anmeldung konnte nicht gesendet werden. Bitte versuche es erneut.'],
    ['Obrigado por se inscrever!', 'Thank you for signing up!', 'Vielen Dank für deine Anmeldung!'],
    ['Obrigado pela sua inscrição!', 'Thank you for signing up!', 'Vielen Dank für deine Anmeldung!']
  ];
  const translate = value => {
    let result = value;
    for (const [source, en, de] of messages) {
      const target = english ? en : de;
      result = result.split(source).join(target);
      if (!english && source !== en) result = result.split(en).join(de);
    }
    return result;
  };
  const set = (element, attribute, value) => {
    if (element.getAttribute(attribute) !== value) element.setAttribute(attribute, value);
  };
  let queued = false;
  const update = () => {
    queued = false;
    set(root, 'aria-label', copy.dialog);
    const close = root.querySelector('#ac-popup-close');
    if (close) set(close, 'aria-label', copy.close);
    const image = root.querySelector('img._form-image');
    if (image) {
      set(image, 'alt', english ? 'Nordhaus home inspiration' : '10 % Rabatt auf deine erste Bestellung');
      if (english && !image.parentElement.querySelector('.nh-popup-artwork__copy')) {
        const frame = image.parentElement;
        frame.classList.add('nh-popup-artwork');
        if (!root.querySelector('#nh-popup-artwork-style')) {
          const style = document.createElement('style');
          style.id = 'nh-popup-artwork-style';
          style.textContent = '#ac-popup-overlay .nh-popup-artwork{position:relative;isolation:isolate}#ac-popup-overlay .nh-popup-artwork img{display:block}#ac-popup-overlay .nh-popup-artwork__copy{position:absolute;inset:0 0 0 50%;background:#f0eae4;color:#181818;display:flex;flex-direction:column;justify-content:center;padding:7% 5% 7% 6%;text-align:left;z-index:1}#ac-popup-overlay .nh-popup-artwork__brand{font:clamp(14px,4vw,20px)/1.2 Georgia,serif!important;display:block;margin-bottom:13%}#ac-popup-overlay .nh-popup-artwork__offer{font:clamp(14px,4vw,20px)/1.2 Arial,sans-serif!important;font-weight:700!important;display:block}#ac-popup-overlay .nh-popup-artwork__detail{font:clamp(12px,3.5vw,18px)/1.3 Arial,sans-serif!important;display:block;margin-top:3%}';
          root.append(style);
        }
        const panel = document.createElement('div');
        panel.className = 'nh-popup-artwork__copy';
        for (const [className, text] of [['brand','Nordhaus'],['offer','10% OFF'],['detail','YOUR FIRST ORDER']]) {
          const span = document.createElement('span');
          span.className = 'nh-popup-artwork__' + className;
          span.textContent = text;
          panel.append(span);
        }
        frame.append(panel);
      }
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script,style,textarea')) continue;
      const next = translate(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    for (const [name, label] of [['fullname', copy.name], ['email', copy.email]]) {
      root.querySelectorAll(`input[name="${name}"]`).forEach(input => {
        set(input, 'placeholder', label);
        set(input, 'aria-label', label);
      });
    }
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  };
  root.addEventListener('invalid', event => {
    const field = event.target;
    if (!(field instanceof HTMLInputElement) || !['fullname','email'].includes(field.name)) return;
    field.setCustomValidity('');
    if (field.validity.valueMissing) field.setCustomValidity(copy.required);
    else if (field.name === 'email' && field.validity.typeMismatch) field.setCustomValidity(copy.invalidEmail);
  }, true);
  root.addEventListener('input', event => {
    if (event.target instanceof HTMLInputElement) event.target.setCustomValidity('');
  });
  new MutationObserver(schedule).observe(root, {childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['placeholder','aria-label']});
  update();
})();
